<!--
 * @Description: 
 * @Author: WangYuhan
 * @Date: 2022-12-09 17:54:05
 * @LastEditTime: 2023-11-01 16:45:31
 * @LastEditors: WangYuhan
-->
<template>
  <div class="logo-container w_54" v-if="isCollapse" key="collapse">
    <router-link class="logo-link" to="/">
      <img :src="groupIconUrl ? groupIconUrl : logo" class="logo" />
    </router-link>
  </div>
  <div v-else class="logo-container w_220">
    <router-link class="logo-link" to="/">
      <img :src="groupIconUrl ? groupIconUrl : logo" class="logo" />
      <h1 class="title">{{ groupName }}</h1>
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SidebarLogo',
  props: {},
  data() {
    return {
      title: '牛运宝2.0',
      logo: require('@/assets/images/icons/qiyemingcheng.png'),
    };
  },
  computed: {
    ...mapGetters(['permission_routes', 'sidebar']),
    groupIconUrl() {
      return this.$store.state.user.groupIconUrl || '';
    },
    groupName() {
      return this.$store.state.user.groupName.replace('有限公司', '') || '';
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
  },
};
</script>

<style lang="scss" scoped>
.w_54 {
  width: 54px;
  & .logo-link {
    height: 100%;
    width: 100%;
    padding-top: 16px;

    & .logo {
      margin-left: 18px !important;
    }
  }
}
.w_220 {
  width: 220px;
}
.logo-container {
  height: 50px;
  background: #2d3158;
  overflow: hidden;
  //   width: 54px;
  display: inline-block;
  float: left;
  position: fixed;
  z-index: 12;
  top: 0;
  left: 0;
  & .logo-link {
    height: 100%;
    width: 100%;
    padding-top: 16px;

    & .logo {
      width: 18px;
      height: 18px;
      margin-right: 8px;
      margin-left: 28px;
      margin-top: 16px;
    }

    & .title {
      display: inline-block;
      margin: 0;
      color: #fff;
      max-width: 140px;
      overflow: hidden;
      font-weight: 600;
      line-height: 18px;
      font-size: 14px;
      font-family: AlimamaShuHeiTi, sans-serif;
      white-space: nowrap;
    }
  }
}
</style>
